/** Annual Report Technical Assistance Request Form (Formstack). */
export const ANNUAL_REPORT_TECHNICAL_ASSISTANCE_FORM_URL =
  'https://peointernational.formstack.com/forms/annual_report_request_formv2';
